"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var SIZE_MAP = {
    sm: 6,
    md: 8,
    lg: 10,
};
var getBackgroundColor = function (dotColor) {
    switch (dotColor) {
        case 'Primary':
        case 'Success':
        case 'Error':
        case 'Warning':
        case 'Gray':
            return variables_1.ThemeColor[dotColor];
        case 'Teal':
        case 'Orange':
        case 'Pink':
        case 'Violet':
            return variables_1.RootColor[dotColor];
    }
};
var Dot = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.color, color = _c === void 0 ? 'Success' : _c, _d = _a.theme, theme = _d === void 0 ? 'dark' : _d, disabled = _a.disabled, props = __rest(_a, ["size", "color", "theme", "disabled"]);
    var backgroundColor = react_2.useMemo(function () { return getBackgroundColor(color); }, [color]);
    var enabledColor = theme === 'dark' ? backgroundColor.DEFAULT : backgroundColor.LIGHT_3;
    return (react_1.jsx(layout_1.Flex, { inline: true, alignItems: "center", justifyContent: "center", css: { padding: 2 } },
        react_1.jsx("div", __assign({}, props, { css: {
                width: SIZE_MAP[size],
                height: SIZE_MAP[size],
                borderRadius: SIZE_MAP[size] / 2,
                backgroundColor: "var(" + (disabled ? backgroundColor.LIGHT_4 : enabledColor) + ")",
            } }))));
};
exports.default = Dot;
